import { useContext } from 'react';

import type { ErrorTracking } from '@sorare/wallet-shared';
import { MessagingContext } from '@sorare/wallet-shared';

import WalletContext from '#src/contexts/wallet/index.tsx';
import type { Args } from '#src/contexts/wallet/index.tsx';
import { NoKeyError } from '#src/lib/errors/index.ts';

type LoadWalletArgs = Pick<Args, 'userPrivateKey'> & { password: string };

const useLoadWallet = () => {
  const { load } = useContext(WalletContext)!;
  const { sendRequest } = useContext(MessagingContext)!;
  return async ({ password, userPrivateKey }: LoadWalletArgs) => {
    try {
      const wallet = await load({ password, userPrivateKey });
      return wallet;
    } catch (e) {
      if (e instanceof NoKeyError) {
        // Swallowing this without reporting it is why Sentry shows no
        // NoKeyError at all while support keeps receiving the tickets.
        sendRequest<ErrorTracking>('errorTracking', e);
        return null;
      }
      throw e;
    }
  };
};

export default useLoadWallet;
